import withErrorBoundary from './withErrorBoundary';

export default withErrorBoundary;
